var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tiptap',{attrs:{"extensions":_vm.extensions,"placeholder":"Write something ..."},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }